import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import GetSacVideos from "../../actions/GetSacVideos";
import DetectDevice from "../../data/DetectDevice";
import Localbase from "localbase";
import SlidingVideoItem from "./SlidingVideoItem";

const ReviewVideosSlider = ({
  header,
  account,
  props,
  left,
  right,
  handleLeft,
  handleRight,
}) => {
  const db = new Localbase();

  const [access, setAccess] = useState(false);
  const [courses, setCourses] = useState(null);

  useEffect(() => {
    db.collection("paths")
      .doc("shorts")
      .get()
      .then(function (data) {
        if (data && data.shorts) {
          setCourses(data.shorts);
        }
      })
      .catch(function () {
        // silent fail - same as original
      });
  }, []);

  const NewGetCourses = async () => {
    const res = await GetSacVideos({
      payload: {
        mode: "live",
        limit: 8,
      },
    });

    // No optional chaining - plain property check
    if (res && res.status === "success") {
      setCourses(res.videos);
      setAccess(res.access);
      db.collection("paths").add(
        {
          shorts: res.videos,
        },
        "shorts",
      );
    }
  };

  useEffect(() => {
    NewGetCourses();
  }, []);

  const scrollContainer = function (direction) {
    var container = document.getElementById("container10");
    if (!container) return;

    var scrollAmount = 0;
    var step = 15;
    var distance = 300;
    var speed = 15;

    var slideTimer = setInterval(function () {
      if (direction === "left") {
        container.scrollLeft -= step;
      } else {
        container.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);
  };

  const device = DetectDevice();

  useEffect(() => {
    if (left) {
      scrollContainer("left");
    }
  }, [left]);

  useEffect(() => {
    if (right) {
      scrollContainer("right");
    }
  }, [right]);

  return (
    <div
      className="w-100 pb-4 "
      style={{
        background: "linear-gradient(180deg, #f5f7fa 0%, #ffffff 100%)",
        position: "relative",
        overflow: "hidden",
        borderRadius: "16px",          
    border: "1px solid #e0e0e0",    
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)", 
      }}
    >
      
      <div
        style={{
          position: "absolute",
          top: 0,
          right: -100,
          width: "400px",
          height: "400px",
          background:
            "radial-gradient(circle, rgba(255, 98, 0, 0.1) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />

      {courses && header ? (
        <div
          className="d-flex mb-5 justify-content-between align-items-center px-4 py-4 rounded-3"
          style={{
            background:
              "linear-gradient(135deg, #1a2847 0%, #253563 50%, #2d4080 100%)",
            color: "#ffffff",
            boxShadow:
              "0 12px 40px rgba(15, 23, 42, 0.15), inset 0 1px 0 rgba(255,255,255,0.1)",
            position: "relative",
            margin: "24px",
            border: "1px solid rgba(255, 255, 255, 0.05)",
            overflow: "hidden",
          }}
        >
          {/* Header gradient overlay */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "1px",
              background:
                "linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)",
              pointerEvents: "none",
            }}
          />

          <h4
            className="mb-0 d-flex align-items-center Student-Reviews"
            style={{
              fontWeight: 700,
              letterSpacing: "-0.5px",
              position: "relative",
              paddingLeft: "16px",
              fontSize: "1.35rem",
              fontFamily: "'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
            }}
          >
            <span
              style={{
                position: "absolute",
                left: 0,
                top: "50%",
                transform: "translateY(-50%)",
                width: "5px",
                height: "28px",
                background: "linear-gradient(180deg, #FF6200 0%, #FF8934 100%)",
                borderRadius: "2.5px",
                boxShadow: "0 4px 12px rgba(255, 98, 0, 0.3)",
              }}
            />
           Recent Student Reviews
          </h4>

          <Link
            to="/shorts"
            className="rounded-pill px-4 py-2 fw-semibold text-decoration-none continue-course"
            style={{
              color: "#FF6200",
              background:
                "linear-gradient(135deg, rgba(255, 98, 0, 0.12), rgba(255, 137, 52, 0.08))",
              border: "1.5px solid #FF6200",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              fontSize: "0.95rem",
              position: "relative",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={function (e) {
              e.currentTarget.style.background =
                "linear-gradient(135deg, rgba(255, 98, 0, 0.2), rgba(255, 137, 52, 0.15))";
              e.currentTarget.style.transform = "translateY(-3px)";
              e.currentTarget.style.boxShadow =
                "0 10px 24px rgba(255, 98, 0, 0.25)";
              e.currentTarget.style.borderColor = "#FF8934";
            }}
            onMouseLeave={function (e) {
              e.currentTarget.style.background =
                "linear-gradient(135deg, rgba(255, 98, 0, 0.12), rgba(255, 137, 52, 0.08))";
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
              e.currentTarget.style.borderColor = "#FF6200";
            }}
          >
            View All Reviews →
          </Link>
        </div>
      ) : null}

      <div
        style={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          px: 3,
        }}
      >
        {device !== "mobile" && (
          <button
            onClick={function () {
              scrollContainer("left");
            }}
            style={{
              background: "linear-gradient(135deg, #FF6200, #FF8934)",
              border: "none",
              borderRadius: "50%",
              width: "48px",
              height: "48px",
              minWidth: "48px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              boxShadow: "0 6px 20px rgba(255, 98, 0, 0.2)",
              position: "relative",
              overflow: "hidden",
              opacity: 0.7,
            }}
            onMouseEnter={function (e) {
              e.currentTarget.style.background =
                "linear-gradient(135deg, #FF8934, #FFB366)";
              e.currentTarget.style.transform = "scale(1.15)";
              e.currentTarget.style.boxShadow =
                "0 12px 30px rgba(255, 98, 0, 0.35)";
              e.currentTarget.style.opacity = "1";
            }}
            onMouseLeave={function (e) {
              e.currentTarget.style.background =
                "linear-gradient(135deg, #FF6200, #FF8934)";
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow =
                "0 6px 20px rgba(255, 98, 0, 0.2)";
              e.currentTarget.style.opacity = "0.7";
            }}
          >
            <ChevronLeft
              style={{ color: "#fff", fontSize: "1.4rem", fontWeight: "bold" }}
            />
          </button>
        )}

        <div
          id="container10"
          className="courses-container slider-videos overflow-auto"
          style={{
            scrollBehavior: "smooth",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            flex: 1,
          }}
        >
          <style>{`
            #container10::-webkit-scrollbar { display: none; }
            
            @media (max-width: 768px) {
              .continue-course {
                padding: 8px 16px !important;
                font-size: 0.9rem !important;
              }
              .Student-Reviews{
                font-size: 1.2rem !important;
              }
            }
            
            @media (max-width: 480px) {
              .continue-course {
                padding: 6px 12px !important;
                font-size: 0.8rem !important;
              }
              .Student-Reviews{
                font-size: 0.95rem !important;
              }
            }
          `}</style>

          <div
            className="mt-1 courses-slider d-flex gap-4 px-4 animate"
            style={{ minWidth: "max-content" }}
          >
            {courses ? (
              courses.map(function (course, index) {
                return (
                  <div
                    key={index}
                    className={"fade-in-bottom delay" + (4 + index) + "s"}
                    style={{
                      transition: "all 0.4s ease",
                      transform: "translateY(0)",
                      opacity: 1,
                    }}
                  >
                    <SlidingVideoItem
                      account={account}
                      access={access}
                      course={course}
                    />
                  </div>
                );
              })
            ) : (
              <div className="text-center w-100 py-5 text-muted">
                Loading student reviews...
              </div>
            )}
          </div>
        </div>

        {device !== "mobile" && (
          <button
            onClick={function () {
              scrollContainer("right");
            }}
            style={{
              background: "linear-gradient(135deg, #FF6200, #FF8934)",
              border: "none",
              borderRadius: "50%",
              width: "48px",
              height: "48px",
              minWidth: "48px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              boxShadow: "0 6px 20px rgba(255, 98, 0, 0.2)",
              position: "relative",
              overflow: "hidden",
              opacity: 0.7,
            }}
            onMouseEnter={function (e) {
              e.currentTarget.style.background =
                "linear-gradient(135deg, #FF8934, #FFB366)";
              e.currentTarget.style.transform = "scale(1.15)";
              e.currentTarget.style.boxShadow =
                "0 12px 30px rgba(255, 98, 0, 0.35)";
              e.currentTarget.style.opacity = "1";
            }}
            onMouseLeave={function (e) {
              e.currentTarget.style.background =
                "linear-gradient(135deg, #FF6200, #FF8934)";
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow =
                "0 6px 20px rgba(255, 98, 0, 0.2)";
              e.currentTarget.style.opacity = "0.7";
            }}
          >
            <ChevronRight
              style={{ color: "#fff", fontSize: "1.4rem", fontWeight: "bold" }}
            />
          </button>
        )}
      </div>
    </div>
  );
};

export default ReviewVideosSlider;